<template>
	<div class="details-item">
		<div :class="labelClass" :title="label" class="label"><slot name="label">{{label}}</slot></div>
		<div :class="primaryClass" :title="primary" class="primary"><slot name="primary">{{primary}}</slot></div>
		<div v-if="useSecondaryLogic" :key="'secondaryLogic'">
			<div
				v-for="n in secondary.length"
				:key="n"
				:class="secondaryClass"
				:title="secondary[n - 1]"
				class="secondary"
			>
				{{secondary[n - 1]}}
			</div>
		</div>
		<div
			v-else
			:key="'nonSecondaryLogic'"
			:class="secondaryClass"
			:title="secondary"
			class="secondary"
		>
			<slot name="secondary">{{secondary}}</slot>
		</div>
	</div>
</template>

<script>
export default {
	name: 'TDetailsItem',
	props: {
		label: String,
		primary: String,
		secondary: { type: [ String, Array ] },
		labelClass: String,
		primaryClass: String,
		secondaryClass: String
	},
	computed: {
		useSecondaryLogic() {
			if (Array.isArray(this.secondary)) {
				return true;
			} else {
				return false;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/_text';
@import '~@/components/evergreen/scss/_colors';

.details-item {
	@extend %font-families-ui;
}

.label {
	@extend %text-small;
	text-transform: uppercase;
	color: get-color($text, 'muted');
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}
.primary {
	@extend %text-default;
	font-weight: 600;
	color: get-color($text, 'dark');
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}
.secondary {
	@extend %text-small;
	color: get-color($text, 'muted');
	white-space: nowrap;
	text-overflow: ellipsis;
	overflow: hidden;
}
</style>
<docs>
```jsx
<div style="width:500px">
<t-details-item label="from" primary="Terminal Tiller" secondary="7038 Tiller" />
</div>
```
</docs>